<template>
    <div class="float-left col text-muted p-item mb-2">
        <small>{{ control.name }}</small><br>
        <ul>
            <li v-for="(value, index) in splitValue()" :key="`DETAIL-${index}`" :class="value.class">
                <span >
                    <i :class="value.icon" :style="'font-size: 1.2rem;'"></i>
                </span>
                {{ value.name }}
            </li>
        </ul>
        
    </div>
</template>

<script>
export default {
    name: 'AuditNoteCheckBox',

    props: {
        control: Object
    },

    methods: {
        splitValue() {
            const result = [];
            if (this.control.valueContents != this.control.oldValueContents) {
                if (this.control.status != 'DELETE') {
                    result.push({name: this.control.valueContents, icon: this.control.valueContents ==  "Y" ? 'mdi mdi-checkbox-marked-outline' : 'mdi mdi-checkbox-blank-outline', class: 'added'});
                }
                if (this.control.status != 'NEW') {
                    result.push({name: this.control.oldValueContents, icon: this.control.oldValueContents ==  "Y" ? 'mdi mdi-checkbox-marked-outline' : 'mdi mdi-checkbox-blank-outline', class: 'deleted'})
                }
            }
            
            return result;
        }
    }
}
</script>

<style scoped>
.deleted {
    color: red !important;
}
.added {
    color: green !important;
}
</style>